import { useTranslation } from 'react-i18next'

import { Button } from '@/components/v2/ui'
import { useMarketplaceProfiles } from '@/hooks/useListingBuilder'
import { EID } from '@/lib/element-ids.registry'

interface MarketplaceSelectorProps {
  value: string
  onChange: (marketplaceCode: string) => void
}

/** Marktplatz-Auswahl als Chips — dynamisch aus den Marketplace-Profilen (Stufe 1). */
export function MarketplaceSelector({ value, onChange }: MarketplaceSelectorProps) {
  const { t } = useTranslation()
  const { data: profiles, isLoading } = useMarketplaceProfiles()

  if (isLoading) {
    return (
      <p className="listing-builder-market-loading text-sm text-muted-foreground" aria-live="polite">
        {t('listingBuilder.loadingMarkets')}
      </p>
    )
  }

  return (
    <div
      className="listing-builder-market-chips flex flex-wrap gap-2"
      role="group"
      aria-label={t('listingBuilder.marketplaceLabel')}
    >
      {(profiles ?? []).map((p) => (
        <Button
          key={p.marketplace_code}
          id={`${EID['listing-builder-market-select']}-${p.marketplace_code}`}
          type="button"
          variant={value === p.marketplace_code ? 'primary' : 'outline'}
          aria-pressed={value === p.marketplace_code}
          onClick={() => onChange(p.marketplace_code)}
        >
          {p.display_name}
        </Button>
      ))}
    </div>
  )
}
